module.exports = __webpack_public_path__ + "img/DemonHunter-bloodelf-f-110.239d2b05.gif";